import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { ADMINISTERING_PRESCRIPTION, ADMINISTER_PRESCRIPTION, CREATE_PRESCRIPTION, CREATING_PRESCRIPTION, GETTING_PRESCRIPTIONS, GET_PRESCRIPTIONS, PRESCRIPTIONS_ERROR } from "../types"

export const createResidentPrescription = (prescriptionPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_PRESCRIPTION,
            payload: true
        })
        const response = await axios.post(`${baseUrl}/prescriptions`, prescriptionPayload, { headers })
        
        dispatch({
            type: CREATE_PRESCRIPTION,
            payload: response.data.data
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: PRESCRIPTIONS_ERROR,
            error
        })
    }
}

export const clearCreatedPrescription = () => async (dispatch) => {    
    dispatch({
        type: CREATE_PRESCRIPTION,
        payload: null
    })
}

export const administerResidentPrescription = (prescriptionId, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: ADMINISTERING_PRESCRIPTION,
            payload: true
        })
        const response = await axios.post(`${baseUrl}/prescriptions/administer/${prescriptionId}`, payload, { headers })
        
        dispatch({
            type: ADMINISTER_PRESCRIPTION,
            payload: response.data.data
        })
        
    }
    catch(error){
        console.log(error)
        dispatch({
            type: PRESCRIPTIONS_ERROR,
            error
        })
    }
}

export const clearAdministeredPrescription = () => async (dispatch) => {    
    dispatch({
        type: ADMINISTER_PRESCRIPTION,
        payload: null
    })
}

export const fetchPrescriptions = (residentId, filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/prescriptions?expand=createdBy,administrations.caregiver,administrations.note&resident=${residentId}`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_PRESCRIPTIONS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_PRESCRIPTIONS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: PRESCRIPTIONS_ERROR,
            error
        })
    }
}
